module.exports = __webpack_public_path__ + "img/upload.17666748.png";